import styled from 'styled-components';

export const FixedContainer = styled.div`
  @media ${(props) => props.theme.device.mobileL} {
    padding: 0 16px;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
  margin: 16px 0 24px;

  @media ${(props) => props.theme.device.mobileL} {
    justify-content: space-between;
  }
`;

export const Sorting = styled.div`
  margin-bottom: 36px;
`;

export const CourseWrapper = styled.div`
  margin: 0 0 24px;
`;

export const Legend = styled.div`
  display: grid;
  grid-template-columns: 80px 2fr repeat(3, 1fr) 75px;
  align-items: center;
  padding: 0 24px;
  gap: 24px;
  margin-bottom: 24px;

  h4 {
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const CourseCardMobile = styled.div`
  width: var(--full-width);
  //margin-left: -16px;
  display: grid;
  grid-template-columns: 130px 1fr;
  gap: 8px;
  padding: 24px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  &.active {
    background-color: ${(props) => props.theme.colors.bgBox};
  }

  .h5 {
    color: #646464;
    text-transform: uppercase;
  }

  .title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .code {
    text-transform: uppercase;
  }

  > :nth-child(even) {
    text-align: right;
  }
`;

export const CourseCard = styled(Legend)`
  padding: 24px;
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  margin-bottom: 8px;

  &.active {
    background-color: ${(props) => props.theme.colors.bgBox};
  }

  .code {
    text-transform: uppercase;
  }
`;

export const RelatedCourseCards = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;

  .related-card {
    padding: 16px;
    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
    display: flex;
    align-items: center;
    gap: 16px;
    max-width: 524px;

    .code {
      text-transform: uppercase;
      min-width: fit-content;
    }

    @media ${(props) => props.theme.device.mobileL} {
      flex-direction: column;
      align-items: flex-start;
      max-width: 100%;
      width: 100%;

      .h3 {
        width: 100%;
      }
    }
  }
`;
